import { isValidCnpj } from '@/utils/cnpj';

export default function CnpjValidation(value) {
    if (!value) {
        return false;
    }

    return isValidCnpj(value);
}
